/* v46.8 on big screens the page is zoomed (see theme.liquid); measured
   screen distances are divided by this before being set as CSS lengths */
window.rvZoom = function () {
  var r = document.documentElement, w = r.offsetWidth;
  var k = w ? r.getBoundingClientRect().width / w : 1;
  return k > 0.5 ? k : 1;
};
/* Revtek theme behaviour.
   No framework, no build step. Every block guards its own elements so a page
   that lacks one does not break the rest. */
(function () {
  'use strict';

  /* ---- mobile navigation drawer ----
     Opens from the left over the page. Closing has to be possible without
     finding the burger again, so the scrim, the close button and Escape all
     do it, and focus is put in the drawer and handed back afterwards. */
  var burger = document.getElementById('burger');
  var mnav = document.getElementById('mnav');
  var scrim = document.getElementById('mnavScrim');
  var mclose = document.getElementById('mnavClose');

  if (burger && mnav) {
    var lastFocus = null;

    var openNav = function () {
      lastFocus = document.activeElement;
      if (scrim) { scrim.hidden = false; void scrim.offsetWidth; scrim.classList.add('open'); }
      mnav.classList.add('open');
      mnav.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mnav-open');
      if (mclose) mclose.focus();
    };

    var closeNav = function () {
      mnav.classList.remove('open');
      mnav.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mnav-open');
      if (scrim) {
        scrim.classList.remove('open');
        // wait for the fade before taking it out of the document
        setTimeout(function () { if (!mnav.classList.contains('open')) scrim.hidden = true; }, 240);
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    burger.addEventListener('click', function () {
      if (mnav.classList.contains('open')) closeNav(); else openNav();
    });
    if (mclose) mclose.addEventListener('click', closeNav);
    if (scrim) scrim.addEventListener('click', closeNav);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mnav.classList.contains('open')) closeNav();
    });
    // following a link should not leave the drawer open behind the new page
    Array.prototype.forEach.call(mnav.querySelectorAll('a'), function (a) {
      a.addEventListener('click', closeNav);
    });
    // and it is a phone pattern: if the window grows past the breakpoint, close it
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && mnav.classList.contains('open')) closeNav();
    });
  }

  /* ---- product gallery ----
     Native scroll-snap does the scrolling; this only keeps the thumbnails,
     counter and arrows in step with wherever the track has landed. */
  var track = document.getElementById('galTrack');
  if (track) {
    var thumbs = document.getElementById('galThumbs');
    var now = document.getElementById('galNow');
    var slides = track.querySelectorAll('.gal__slide');
    var tbs = thumbs ? thumbs.querySelectorAll('.gal__t') : [];
    var total = document.getElementById('galTotal');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var count = now ? now.parentNode : null;
    /* The count box holds the width it has on the first photo, icon and all,
       so it does not shrink when the icon goes. Measured again whenever the
       layout can change (the icon only shows on phones). */
    var lockCount = function () {
      if (!count) return;
      count.style.minWidth = '';
      var had = count.classList.contains('is-first');
      count.classList.add('is-first');
      count.style.minWidth = (count.getBoundingClientRect().width / window.rvZoom()) + 'px';
      if (!had) count.classList.remove('is-first');
    };

    var index = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var go = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    };
    var sync = function () {
      var i = index();
      /* desktop counts in two figures (01 / 04), phones in one (1 / 4) */
      var wide = window.matchMedia('(min-width: 901px)').matches;
      if (now) now.textContent = wide ? pad(i + 1) : i + 1;
      if (total) total.textContent = wide ? pad(slides.length) : slides.length;
      /* the photo icon shows on the first photo only */
      if (count) count.classList.toggle('is-first', i === 0);
      Array.prototype.forEach.call(tbs, function (t, n) { t.classList.toggle('is-on', n === i); });
      if (tbs[i] && thumbs && thumbs.scrollHeight > thumbs.clientHeight + 1) {
        var t = tbs[i];
        if (t.offsetTop < thumbs.scrollTop ||
            t.offsetTop + t.offsetHeight > thumbs.scrollTop + thumbs.clientHeight) {
          thumbs.scrollTo({ top: t.offsetTop - 8, behavior: 'smooth' });
        }
      }
    };

    var queued;
    track.addEventListener('scroll', function () {
      clearTimeout(queued);
      queued = setTimeout(sync, 60);
    }, { passive: true });
    Array.prototype.forEach.call(tbs, function (t, n) {
      t.addEventListener('click', function () { go(n); });
    });
    Array.prototype.forEach.call(document.querySelectorAll('.gal__nav'), function (b) {
      b.addEventListener('click', function () { go(index() + parseInt(b.dataset.step, 10)); });
    });
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });
    window.addEventListener('resize', function () { lockCount(); sync(); });
    lockCount();
    sync();
    window.RevtekGoToSlide = go;
  }

  /* ---- variant options ----
     The buttons drive a hidden select so the real Shopify form still submits
     a variant id, and the theme keeps working with JS disabled. */
  var optRows = document.querySelectorAll('.opt__row[data-option-index]');
  var variantSelect = document.getElementById('variantId');
  if (optRows.length && variantSelect && window.RevtekVariants) {
    var chosen = [];
    Array.prototype.forEach.call(optRows, function (row) {
      var on = row.querySelector('.opt__b.is-on');
      chosen[parseInt(row.dataset.optionIndex, 10)] = on ? on.dataset.value : null;

      row.addEventListener('click', function (e) {
        var b = e.target.closest('.opt__b');
        if (!b || b.disabled) return;
        Array.prototype.forEach.call(row.querySelectorAll('.opt__b'), function (x) {
          x.classList.toggle('is-on', x === b);
        });
        var i = parseInt(row.dataset.optionIndex, 10);
        chosen[i] = b.dataset.value;
        // keep the value shown in the label in step
        var out = document.querySelector('[data-option-value="' + i + '"]');
        if (out) out.textContent = b.dataset.value;
        matchVariant();
    firstMatch = false;
      });
    });

    var firstMatch = true;
    function matchVariant() {
      var match = window.RevtekVariants.filter(function (v) {
        return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
      var btn = document.getElementById('addToCart');
      var price = document.getElementById('pPrice');
      if (match) {
        variantSelect.value = match.id;
        /* page load always opens on the first photo; only a choice the
           shopper makes moves the gallery to that variant's photo */
        if (!firstMatch && match.media > 0 && typeof window.RevtekGoToSlide === 'function') {
          window.RevtekGoToSlide(match.media - 1);
        }
        if (price && match.price != null) price.textContent = window.RevtekMoney(match.price);
        /* v47.1 the SKU follows the chosen options */
        var sku = document.getElementById('pSku');
        if (sku && match.sku) sku.textContent = match.sku;
        if (btn) {
          btn.disabled = !match.available;
          // write into the label span only: btn.textContent would replace every
          // child, including the cart icon
          var label = btn.querySelector('.btn-label') || btn;
          label.textContent = match.available ? 'Add to cart' : 'Sold out';
        }
      } else if (btn) {
        btn.disabled = true;
        var lbl = btn.querySelector('.btn-label') || btn;
        lbl.textContent = 'Unavailable';
      }
    }
    matchVariant();
  }

  /* ---- quantity ---- */
  var qty = document.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    qty.addEventListener('click', function (e) {
      if (e.target.tagName !== 'BUTTON') return;
      e.preventDefault();
      var n = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, n + (e.target.dataset.step === 'up' ? 1 : -1));
    });
  }

  /* ---- collection filter rail ----
     Shopify's own filtering is server side, so these just submit the form.
     Left as a progressive enhancement: the form works without this. */
  /* phone filters drawer */
  var cfPanel = document.getElementById('collFilters');
  var cfOpenBtn = document.getElementById('cfOpen');
  var cfScrim = document.getElementById('cfScrim');
  if (cfPanel && cfOpenBtn) {
    var cfSet = function (open) {
      cfPanel.classList.toggle('is-open', open);
      document.body.classList.toggle('cf-open', open);
      cfOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (cfScrim) cfScrim.hidden = !open;
    };
    cfOpenBtn.addEventListener('click', function () { cfSet(true); });
    ['cfClose', 'cfDone'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', function () { cfSet(false); });
    });
    if (cfScrim) cfScrim.addEventListener('click', function () { cfSet(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cfSet(false); });
    /* after a filter is ticked the page reloads; reopen the drawer so the
       next choice can be made straight away */
    try {
      if (sessionStorage.getItem('cfReopen') === '1' && window.matchMedia('(max-width: 1000px)').matches) cfSet(true);
      sessionStorage.removeItem('cfReopen');
    } catch (e) {}
    cfPanel.addEventListener('change', function () {
      try { if (cfPanel.classList.contains('is-open')) sessionStorage.setItem('cfReopen', '1'); } catch (e) {}
    });
    cfPanel.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.fopt, #cClear');
      if (a && cfPanel.classList.contains('is-open')) { try { sessionStorage.setItem('cfReopen', '1'); } catch (er) {} }
    });
  }
  var filterForm = document.getElementById('filterForm');
  if (filterForm) {
    filterForm.addEventListener('change', function () { filterForm.submit(); });
    var clear = document.getElementById('cClear');
    if (clear) {
      clear.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = clear.getAttribute("data-url") || window.location.pathname;
      });
    }
  }
})();


/* Scroll rail for the card strips.
   The native bar is an overlay on phones: it fades in while you drag and
   vanishes after, and no CSS can pin it open. This draws one instead, sitting
   under the row rather than over a card, and only where the row actually
   scrolls. Pointer events stay on the strip itself, so the rail is an
   indicator and never steals a swipe. */
(function () {
  var strips = document.querySelectorAll('[data-strip]');
  Array.prototype.forEach.call(strips, function (strip) {
    var rail = strip.parentNode.querySelector('[data-strip-rail]');
    if (!rail) return;
    var thumb = rail.firstElementChild;

    function update() {
      var extra = strip.scrollWidth - strip.clientWidth;
      if (extra < 2) { rail.hidden = true; return; }
      rail.hidden = false;
      var ratio = strip.clientWidth / strip.scrollWidth;
      var travel = 1 - ratio;
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.left = (travel ? (strip.scrollLeft / extra) * travel * 100 : 0) + '%';
    }

    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(strip);
    update();
  });
})();


/* View all: the button is moved so its label sits on the heading's baseline.
   The brackets are pseudo-elements and cannot be measured, so their offset
   inside the button is a fixed ratio in CSS rather than something computed:
   canvas metrics for this face disagreed with what the browser painted by
   several pixels, which made the computed version drift between screen sizes.
   A constant is identical at every width by construction. */
(function () {
  var CAP_RATIO = 0.73;   // Archivo cap height, as a share of font size
  var rows = document.querySelectorAll('.fit-sechead__row');
  if (!rows.length) return;

  function baselineOf(el) {
    var s = document.createElement('span');
    s.style.cssText = 'display:inline-block;width:0;height:0;overflow:hidden;vertical-align:baseline';
    el.appendChild(s);
    var y = s.getBoundingClientRect().bottom;
    s.remove();
    return y;
  }

  function align(row) {
    var btn = row.querySelector('.fit-btn--sm');
    var heading = row.querySelector('h2');
    if (!btn || !heading) return;
    btn.style.setProperty('--vb-lift', '0px');
    /* v46.7 on narrow phones the heading is shrunk to fit; shrink "View all"
       with it so the two keep the same proportion they have on a standard
       phone (label = 0.427 x heading size, never above its normal 11px) */
    btn.style.fontSize = '';
    if (window.innerWidth <= 900) {
      var hs = parseFloat(getComputedStyle(heading).fontSize) || 28;
      var fs = Math.min(parseFloat(getComputedStyle(btn).fontSize) || 11, hs * 0.427);
      btn.style.setProperty('font-size', fs.toFixed(2) + 'px', 'important');
    }
    var label = btn.querySelector('.vb-lb');
    if (label) label.style.setProperty('--vb-lb-y', '0px');

    /* 1. The button's height is exactly one bracket, so its bottom edge is the
          bottom of the brackets. Put that on the heading's baseline. */
    var lift = (baselineOf(heading) - btn.getBoundingClientRect().bottom) / window.rvZoom();
    btn.style.setProperty('--vb-lift', lift.toFixed(2) + 'px');

    /* 2. Centre the label's capitals between the brackets, not its box. An
          all-caps word sits high in its line box because the descender space
          below it is empty, so flex centring leaves the letters above centre.
          CAP_RATIO is Archivo's cap height as a share of its size; with the
          baseline measured, that gives where the capitals actually sit. */
    if (label) {
      var brk = btn.querySelector('.vb-br');
      if (brk) {
        var brkRect = brk.getBoundingClientRect();
        var brkCentre = (brkRect.top + brkRect.bottom) / 2;
        var size = parseFloat(getComputedStyle(label).fontSize) || 11;
        var capCentre = baselineOf(label) - (CAP_RATIO * size * window.rvZoom()) / 2;
        label.style.setProperty('--vb-lb-y', ((brkCentre - capCentre) / window.rvZoom()).toFixed(2) + 'px');
      }
    }
  }

  function run() { Array.prototype.forEach.call(rows, align); }

  /* the heading fitter resizes the heading independently, so this has to run
     again once it settles or the measurement is taken against a stale size */
  run();
  window.addEventListener('resize', run);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { requestAnimationFrame(run); });
  }
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () { requestAnimationFrame(run); });
    Array.prototype.forEach.call(rows, function (row) {
      var h = row.querySelector('h2');
      if (h) ro.observe(h);
    });
  }
})();




/* v34.4 — collection title always on one line: if it is wider than the
   space, the type steps down until it fits (never below 14px) */
(function () {
  var h = document.querySelector('.collhead h1');
  if (!h) return;
  function fit() {
    h.style.fontSize = '';
    var size = parseFloat(getComputedStyle(h).fontSize);
    var guard = 0;
    while (h.scrollWidth > h.clientWidth + 1 && size > 14 && guard < 60) {
      size -= 0.5; h.style.fontSize = size + 'px'; guard++;
    }
  }
  fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 80); });
})();

/* v36.5 — add to cart without leaving the page. Product page and product
   card forms post to Shopify in the background; the header count updates,
   the button briefly reads "Added", and a small note offers "View cart". */
(function () {
  function isAddForm(f) { return f && f.tagName === 'FORM' && /\/cart\/add/.test(f.getAttribute('action') || ''); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  var toastEl, toastTimer;
  function toast(msg, ok) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + msg + '</span>' + (ok ? '<a href="' + root() + 'cart">View cart</a>' : '');
    toastEl.classList.toggle('is-err', !ok);
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  function setCount(n) {
    var cart = document.querySelector('.hicons .cart');
    if (!cart) return;
    var badge = cart.querySelector('.cart__n');
    if (n > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'cart__n'; cart.appendChild(badge); }
      badge.textContent = '(' + n + ')';
      cart.setAttribute('aria-label', 'Cart, ' + n + ' item' + (n === 1 ? '' : 's'));
    } else if (badge) { badge.remove(); cart.setAttribute('aria-label', 'Cart'); }
  }
  var TICK = '<svg viewBox="0 0 12 10" width="12" height="10" fill="none" aria-hidden="true"><path d="M1 5.2 4.3 8.5 11 1.5" stroke="currentColor" stroke-width="2"/></svg>';
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form) || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return;
    var before = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    fetch(root() + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart');
        return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        toast('Added to cart', true);
        if (btn) {
          btn.classList.remove('is-busy'); btn.classList.add('is-added');
          var lbl = btn.querySelector('.card-add__txt');
          if (lbl) { lbl.textContent = 'Added'; } else { btn.innerHTML = TICK + '<span>Added</span>'; }
          setTimeout(function () { btn.innerHTML = before; btn.classList.remove('is-added'); btn.disabled = false; }, 1800);
        }
      })
      .catch(function (err) {
        toast(err.message || 'Could not add to cart', false);
        if (btn) { btn.innerHTML = before; btn.classList.remove('is-busy'); btn.disabled = false; }
      });
  });
})();

/* v37.2 — measure the announcement bar and header for the sticky header */
(function () {
  var group = document.querySelector('.announce') && document.querySelector('.announce').closest('.shopify-section');
  function measure() {
    var a = document.querySelector('.announce'), h = document.querySelector('.header-wrapper');
    if (group && a) group.style.setProperty('--ann-h', a.offsetHeight + 'px');
    if (h) document.documentElement.style.setProperty('--hdr-h', h.offsetHeight + 'px');
    var hb = document.querySelector('.hbar');
    if (hb) document.documentElement.style.setProperty('--hbar-h', hb.offsetHeight + 'px');
  }
  measure();
  window.addEventListener('resize', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
})();

/* v40.2 — section sub-lines stay on one line: shrink the type until it fits */
(function () {
  var ps = document.querySelectorAll('.fit-sechead p');
  if (!ps.length) return;
  // Each line is shrunk until it fits, then every subheading on the page takes
  // the smallest of those sizes, so they all read at the same size.
  function fit() {
    var min = Infinity;
    Array.prototype.forEach.call(ps, function (p) {
      p.style.fontSize = '';
      if (!p.clientWidth) return;
      var size = parseFloat(getComputedStyle(p).fontSize), guard = 0;
      while (p.scrollWidth > p.clientWidth + 1 && size > 7.5 && guard < 80) { size -= 0.25; p.style.fontSize = size + 'px'; guard++; }
      if (size < min) min = size;
    });
    if (min === Infinity) return;
    Array.prototype.forEach.call(ps, function (p) { p.style.fontSize = min + 'px'; });
  }
  fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 80); });
})();

/* v41.8 copyright year: Shopify can serve a cached page, so the year Liquid
   printed may be stale across New Year. Set it from the visitor's clock. */
(function () {
  var y = String(new Date().getFullYear());
  Array.prototype.forEach.call(document.querySelectorAll('.js-year'), function (e) { if (e.textContent !== y) e.textContent = y; });
})();

/* v42.3 product options stay on one line: a row that is wider than its space
   has its text, thumbnails and padding scaled down together until it fits. */
(function () {
  var rows = document.querySelectorAll('.pdp .opt__row:not(.opt__row--colour)');
  if (!rows.length) return;
  function fitRow(row) {
    var btns = row.querySelectorAll('.opt__b');
    Array.prototype.forEach.call(btns, function (b) { b.style.zoom = ''; });
    row.style.zoom = '';
    if (!row.clientWidth || row.scrollWidth <= row.clientWidth + 1) return;
    var z = 1, guard = 0;
    while (row.scrollWidth > row.clientWidth + 1 && z > 0.6 && guard < 40) {
      z -= 0.02; guard++;
      Array.prototype.forEach.call(btns, function (b) { b.style.zoom = z; });
    }
  }
  function fit() { Array.prototype.forEach.call(rows, fitRow); }
  fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 80); });
})();

/* v43.7 keep the stock note on the price line: shrink the price (never below
   22px) only as far as needed for the note to fit beside it */
(function () {
  var line = document.querySelector('.pdp .buy__priceline');
  var price = line && line.querySelector('.buy__price');
  var note = line && line.querySelector('.buy__stock');
  if (!price || !note) return;
  function oneLine() { return note.getBoundingClientRect().top < price.getBoundingClientRect().bottom - 2; }
  function fit() {
    price.style.fontSize = '';
    if (window.matchMedia('(max-width: 600px)').matches) return; /* phones: note sits under the price */
    var size = parseFloat(getComputedStyle(price).fontSize), guard = 0;
    while (!oneLine() && size > 22 && guard < 60) { size -= 0.5; price.style.fontSize = size + 'px'; guard++; }
    if (!oneLine()) price.style.fontSize = '';
  }
  fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 80); });
})();


/* v45.8 short pages end exactly at the bottom of the screen on every device.
   The page is made exactly as tall as the visible screen (window.innerHeight,
   which every phone browser reports as what you can actually see), so on a
   short page the bottom of the footer meets the bottom of the screen with no
   scrolling and nothing below it. Long pages are unaffected. Re-measured when
   the screen size changes (rotation, address bar, window resize). */
(function () {
  var body = document.body;
  var main = document.getElementById('main');
  if (!body || !main) return;
  function fit() {
    body.style.minHeight = (window.innerHeight / window.rvZoom()) + 'px';
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(fit, 50); }
  fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', soon);
  window.addEventListener('orientationchange', soon);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', soon);
})();
